<template>
  <div class="mx-auto max-w-prose lg:col-span-3 lg:mx-0">
    <div class="text-base font-bold text-yellow-400 uppercase">Overview</div>
    <h2 class="mt-0.5 text-3xl font-extrabold text-white">
      {{ blok.heading }}
    </h2>
    <LazyMarketingContentCopy :content="blok.content" class="mt-4" />
    <div
      v-if="blok.content_tabs && blok.content_tabs.length !== 0"
      class="mt-6 mb-16"
    >
      <LazyMarketingContentTabs :blok="{ content_tabs: blok.content_tabs }" />
    </div>
    <UCard
      v-if="blok.links && blok.links.length > 1"
      :ui="{
        root: 'mt-4 bg-neutral-900/40 backdrop-blur-lg h-fit',
        body: '!p-2 grid grid-cols-1 gap-2 md:grid-cols-2',
      }"
    >
      <div v-for="(link, index) in blok.links" :key="index">
        <UButton
          variant="subtle"
          :to="link.link?.url"
          trailing-icon="i-lucide-external-link"
          :target="link.link?.target"
          class="w-full justify-center"
        >
          {{ link.link?.title }}
        </UButton>
      </div>
    </UCard>
    <div
      v-if="blok.images && blok.images.length !== 0"
      class="mt-10 mb-16 md:mt-16 md:mb-20"
    >
      <LazyMarketingContentCarouselImage :blok="{ images: blok.images }" />
    </div>
    <div
      v-if="blok.faqs && blok.faqs.length !== 0"
      class="mt-8 mb-16 block lg:hidden"
    >
      <LazyMarketingContentFaqs
        :blok="{ headline: blok.heading }"
        :faqs="blok.faqs"
      />
    </div>
    <div
      v-if="
        blok.downloads &&
        blok.downloads.length !== 0 &&
        !route.path.includes('/locations/')
      "
      class="mt-8 mb-16"
    >
      <LazyMarketingContentDownloads
        :blok="{ headline: blok.heading }"
        :downloads="blok.downloads"
      />
    </div>
    <div
      v-if="blok.reviews && blok.reviews.length !== 0"
      :class="[
        'border-t border-yellow-400 pt-12',
        blok.faqs?.length === 0 ? 'mt-12' : '',
      ]"
    >
      <LazyMarketingContentCarouselReview :blok="{ reviews: blok.reviews }" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  LinkStoryblok,
  MultiassetStoryblok,
  ReviewStoryblok,
  TabContentStoryblok,
} from '~/types/component-types-sb';

const route = useRoute();

interface Props {
  blok: {
    heading?: string;
    content?: any; // Using any here as it's a complex richtext type
    content_tabs?: TabContentStoryblok[];
    links?: LinkStoryblok[];
    images?: MultiassetStoryblok;
    faqs?: any[]; // Using any here as it's a complex type
    downloads?: MultiassetStoryblok;
    reviews?: ReviewStoryblok[];
  };
}

defineProps<Props>();
</script>
